interface FactorCard {
  icon: string;
  title: string;
  description: string;
}

const factors: FactorCard[] = [
  {
    icon: "ri-building-2-line",
    title: "Company Size",
    description: "Your pricing scales with your organisation size, from small teams to large enterprises with thousands of users.",
  },
  {
    icon: "ri-apps-2-line",
    title: "Selected Modules",
    description: "Choose the modules that matter to your business. Pay only for what you need and add more as you grow.",
  },
  {
    icon: "ri-settings-3-line",
    title: "Implementation Scope",
    description: "Simple deployments cost less. Complex multi-branch rollouts with data migration and custom configuration adjust the scope.",
  },
  {
    icon: "ri-plug-line",
    title: "Integrations",
    description: "Native integrations are included. Custom API integrations or third-party system connections may affect your plan.",
  },
  {
    icon: "ri-headphone-line",
    title: "Support Level",
    description: "From standard email support to dedicated account management, your support tier is tailored to your operational needs.",
  },
];

export default function HowPricingWorks() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-950">
      <div className="section-padding">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              How Our{" "}
              <span className="text-emerald-accent">Pricing Works</span>
            </h2>
            <p className="text-base sm:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              StackMap pricing is designed around your business needs, not a one-size-fits-all model. 
              Your final plan depends on these key factors.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {factors.map((factor) => (
              <div
                key={factor.title}
                className="glass-card p-5 md:p-6 flex flex-col items-center text-center group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-accent/10 border border-emerald-accent/20 mb-4">
                  <i className={`${factor.icon} text-emerald-accent text-xl`} />
                </div>
                <h4 className="text-sm font-semibold text-white mb-2">{factor.title}</h4>
                <p className="text-xs text-silver-400 leading-relaxed">{factor.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}